// Stale time for genuinely static reference data; everything else is live by
// default (see queryClient.ts)
export const STATIC_DATA_STALE_TIME_MS = 1000 * 60 * 10
